import { AppState, AppThunk } from "@Store/index";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import fetchBookingDetails from "./fetchBookingDetails";

interface BookingDetailsData {
  readyStatus: "invalid" | "request" | "success" | "failure";
  error: string | null;
  inventoryId: string | null;
  data: any;
}

export const initialState: BookingDetailsData = {
  readyStatus: "invalid",
  error: null,
  inventoryId: null,
  data: null,
};

const bookingDetailsData = createSlice({
  name: "bookingDetailsData",
  initialState,
  reducers: {
    getBookingDetailsRequesting: (state: BookingDetailsData, { payload }: PayloadAction<any>) => {
      state.readyStatus = "request";
      state.inventoryId = payload.inventoryId;
      if (__CLIENT__) {
        window.scrollTo(0, 0);
      }
    },
    getBookingDetailsSuccess: (state: BookingDetailsData, { payload }: PayloadAction<any>) => {
      state.readyStatus = "success";
      state.data = payload.data;
    },
    getBookingDetailsFailure: (state: BookingDetailsData, { payload }: PayloadAction<any>) => {
      state.readyStatus = "failure";
      state.error = JSON.stringify(payload);
    },
  },
});

const shouldFetchBookingDetails = (state: AppState, inventoryId?: string) => {
  const { readyStatus, inventoryId: currentInventoryId } = state.bookingDetailsData;
  // Fetch if invalid or if inventory ID has changed (for SPA navigation)
  if (readyStatus === "invalid") return true;
  if (inventoryId && currentInventoryId && inventoryId !== currentInventoryId) return true;
  return false;
};

export { shouldFetchBookingDetails };

export const fetchBookingDetailsIfNeeded =
  (props: any): AppThunk =>
  (dispatch, getState: any) => {
    const inventoryId = __CLIENT__ ? props?.match?.params?.id : props?.params?.id;

    let token = "";
    if (!__CLIENT__) {
      token = props.req?.cookies?.user_auth_token || "";

      // SSR: Redirect to /profile/leads if user is not logged in
      if (!token && props.staticContext) {
        props.staticContext.url = "/profile/leads";
        return null;
      }
    }

    if (__CLIENT__ && getState().router.action === "PUSH") {
      window.scrollTo(0, 0);
    }

    if (shouldFetchBookingDetails(getState(), inventoryId)) {
      return dispatch(fetchBookingDetails({ inventoryId, token }));
    }
    return null;
  };

export default bookingDetailsData.reducer;
export const { getBookingDetailsRequesting, getBookingDetailsSuccess, getBookingDetailsFailure } =
  bookingDetailsData.actions;
